import { Tooltip, TooltipProps, styled } from '@mui/material';

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  zIndex: 1400,
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: 'rgba(233, 236, 250, 1)',
    color: '#120242',
    fontSize: '13px',
    fontWeight: 500,
    padding: '8px 12px 8px 12px',
    gap: '4px',
    borderRadius: '8px'
  },

  [`& .MuiTooltip-arrow`]: {
    color: 'rgba(233, 236, 250, 1)',
    left: '10px' // Adjust this value as needed
  }
});
